function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.714 0a3.714 3.714 0 012.823 6.131l.154.155h.452L10 9.143 9.143 10 6.286 7.143V6.69l-.155-.154A3.714 3.714 0 113.714 0zm0 1.143a2.56 2.56 0 00-2.571 2.571 2.56 2.56 0 002.571 2.572 2.56 2.56 0 002.572-2.572 2.56 2.56 0 00-2.572-2.571z",
  fill: "#3864FB"
});

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgSearch;